import React, { useState, useRef, useEffect } from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import "./LearningCalendarContent.css";
import LearningCalendarData from '../LearningCalendar/LearningCalendarData.json';
import LearningCalendarFilters from '../LearningCalendar/LearningCalendarFilters';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { parse } from 'date-fns';
import AdminPage from "./Admin/AdminPage";
import { deleteSession, fetchSessions, updateSession } from "../Redux/AdminSlice";
import axios from "axios";
import Alert from '@mui/material/Alert';
import CustomCalendar from "./CustomCalendar";
import { useMsal } from "@azure/msal-react";
import { Box } from '@mui/material';
import './CustomCalendar.css';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
const LearningCalendarComponent = (props) => {
    //const [filteredData, setFilteredData] = useState(LearningCalendarData);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const ref = useRef(null);
    const { sessions, error, isLoading } = useSelector((state) => state.admin);
    const [filteredData, setFilteredData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const setDateRange = ([start, end]) => {
        setStartDate(start);
        setEndDate(end);
    };
    const [filters, setFilters] = useState({
        country: "India",
        capability: '',
        category: '',
        modeDelivery: '',
        targetAudience: '',
        searchTerm: '',
        startDate: null,
        endDate: null
    });
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSessions());
    }, [dispatch]);

    useEffect(() => {
  if (sessions) {
    handleFilterChange(filters);
  }
}, [sessions]);

    const { instance } = useMsal();
    const [showUser, setShowUser] = useState(false);
    const usersList = [
        "varsha.a.tyagi",
        "h.srinivasan",
        "jeevadharani.ramanan",
        "kusume.sridhar",
        "potnuru.sandeep",
        "lakshay.c.gupta",
    "dhaval.atul.pantojee",
      ];
      const activeAccount = instance.getActiveAccount();
      let activeUsername = "";
      if (activeAccount) activeUsername = activeAccount.username;
    
      useEffect(() => {
        if (
          activeAccount &&
          activeAccount.idTokenClaims &&
          usersList.includes(activeAccount.idTokenClaims.enterpriseID)
        ) {
          setShowUser(true);
        }
      }, [instance]);

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editCourse, setEditCourse] = useState(null);
    const [editForm, setEditForm] = useState({});

    const confirmDelete = async () => {
        if (!selectedCourse) return;
        await dispatch(deleteSession(selectedCourse.SId));
        setDeleteModalOpen(false);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditForm((prev) => ({ ...prev, [name]: value }));
    };

    const saveEditChanges = async () => {
    const formattedForm = {
        ...editForm,
        SessionStartDate: editForm.SessionStartDate?.split("T")[0] || editForm.SessionStartDate,
        SessionEndDate: editForm.SessionEndDate?.split("T")[0] || editForm.SessionEndDate,
    };

    await dispatch(updateSession(editCourse.SId, formattedForm));
    setEditModalOpen(false);
    };

    const handleFilterChange = (newFilters) => {
        const updatedFilters = { ...filters, ...newFilters };
        setFilters(updatedFilters);

        let result = [...sessions];

        const {
            country,
            capability,
            category,
            modeDelivery,
            targetAudience,
            searchTerm,
            startDate,
            endDate
        } = updatedFilters;


        if (country) {
            result = result.filter(t => t.Country === country);
        }
        if (capability) {
            result = result.filter(t => t.Capability === capability);
        }
        if (category) {
            result = result.filter(t => t.Category === category);
        }
        if (modeDelivery) {
            result = result.filter(t => t.ModeOfDelivery === modeDelivery);
        }
        if (targetAudience) {
            result = result.filter(t => t.TargetAudienceLevel === targetAudience);
        }
        if (searchTerm) {
            const lower = searchTerm.toLowerCase();
            result = result.filter(t =>
                (t.CourseName && t.CourseName.toLowerCase().includes(lower)) ||
                (t.Country && t.Country.toLowerCase().includes(lower)) ||
                (t.Capability && t.Capability.toLowerCase().includes(lower)) ||
                (t.Category && t.Category.toLowerCase().includes(lower)) ||
                (t.ModeOfDelivery && t.ModeOfDelivery.toLowerCase().includes(lower)) ||
                (t.TargetAudienceLevel && t.TargetAudienceLevel.toLowerCase().includes(lower))
            );
        }

        const start = startDate ? moment(startDate).startOf("day") : null;
        const end = endDate ? moment(endDate).endOf("day") : null;

        if (start || end) {
            result = result.filter(t => {
                const sessionStart = moment(t.SessionStartDate);

                if (start && end) {
                    return sessionStart.isSameOrAfter(start) && sessionStart.isSameOrBefore(end);
                }

                if (start) {
                    return sessionStart.isSameOrAfter(start);
                }

                if (end) {
                    return sessionStart.isSameOrBefore(end);
                }

                return true;
            });
        }

        setFilteredData(result);
        setCurrentPage(1);
    };

    let paginatedData = filteredData;
    let indexOfFirstItem = 0;
    let indexOfLastItem = filteredData?.length || 0;
    let totalPages = 1;

    if (itemsPerPage !== -1) {
        indexOfLastItem = currentPage * itemsPerPage;
        indexOfFirstItem = indexOfLastItem - itemsPerPage;
        paginatedData = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
        totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    }
    // const formatMonth = (date) =>
    //     new Date(date).toLocaleString('default', { month: 'long' });

    // let monthRange = '';
    
    // if (startDate && endDate) {
    //     const startMonth = formatMonth(startDate);
    //     const endMonth = formatMonth(endDate);

    //     monthRange = startMonth === endMonth
    //         ? startMonth
    //         : `${startMonth} - ${endMonth}`;
    // } else if (startDate) {
    //     monthRange = formatMonth(startDate);
    // } else {
    //     monthRange = new Date().toLocaleString('default', { month: 'long' });
    // }
    const formatMonth = (date) =>
        new Date(date).toLocaleString('default', { month: 'long' });

    let monthRange = '';

    if (paginatedData?.length > 0) {
        const validDates = paginatedData
            .map(item => new Date(item.SessionStartDate))
            .filter(date => !isNaN(date));

        const uniqueMonths = [
            ...new Set(validDates.map(date => formatMonth(date)))
        ];

        if (uniqueMonths.length === 1) {
            monthRange = uniqueMonths[0];
        } else if (uniqueMonths.length > 1) {
            monthRange = `${uniqueMonths[0]} - ${uniqueMonths[uniqueMonths.length - 1]}`;
        } else {
            monthRange = new Date().toLocaleString('default', { month: 'long' });
        }
    } else {
        monthRange = new Date().toLocaleString('default', { month: 'long' });
    }
    return (
        <div className="lc_container">
        {/* <p className="l-tt-special-note">Note: Training schedules will recommence in September 2026 following the completion of the current deferral period.</p> */}
            {error && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
            <AdminPage></AdminPage>
            <h2 className="header_lc">List of Trainings in {monthRange}</h2>
            <p className="l-tt_note">*Time WBSe is not applicable for the Blended/ Self-paced Trainings & Microsoft VILT sessions.</p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <LearningCalendarFilters data={filteredData} onFilterChange={handleFilterChange}
                    startDate={startDate}
                    endDate={endDate}
                    setDateRange={setDateRange} />
            </LocalizationProvider>
            <div className="lc_calendar_list">
                {/* Left Side Trainings*/}
                <div className="lc_calendar_scrollable">
                    <div className="lc_filter_list">
                        <div className="lc_page_dropdown">
                            Training list per page
                            <select
                                value={itemsPerPage === -1 ? 'all' : itemsPerPage.toString()}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setItemsPerPage(value === 'all' ? -1 : Number(value));
                                    setCurrentPage(1);
                                }}
                            >
                                {[5, 10, 15, 20].map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                                <option value="all">All</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc_legend">
                        <div><span className="lc_dot_purple"></span> Today's Trainings</div>
                        <div><span className="lc_dot_yellow"></span> Upcoming Trainings</div>
                    </div>
                    {isLoading ? (
                        <div className="lc_loading">Loading...</div>
                    ) : !error && paginatedData?.length === 0 ? (
                        <div className="lc_no_data">No data found.</div>
                    ) : (
                        paginatedData?.map((training, index) => {
                            const today = new Date().toDateString();
                            const startDate = new Date(training.SessionStartDate).toDateString();
                            const trainingStart = new Date(training.SessionStartDate);

                            let borderClass = "";
                            if (startDate === today) {
                                borderClass = "lc_today";
                            }else if (moment(training.SessionStartDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
                                borderClass = "lc_today";
                            }
                             else if (trainingStart > new Date()) {
                                borderClass = "lc_upcoming";
                            }

                            return (
                                <div className={`lc_calendar_text ${borderClass}`} key={index}>
                                    {/* Date section */}
                                    <div className="lc_date_sec">
                                        {trainingStart.toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short'
                                        })}                     
                                    </div>

                                    <div className="lc_dotted_divider"></div>

                                    {/* Details Section */}
                                    <div className="lc_details_sec">
                                        <div>
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/target_audience.png"} alt="target" /> {training.TargetAudienceLevel}
                                            </span>
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/mode.png"} alt="mode" /> {training.ModeOfDelivery}
                                            </span>
                                        </div>

                                        <h2>{training.CourseName}</h2>

                                        <div>
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/calendar.png"} alt="calendar" />
                                                {new Date(training.SessionStartDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })} to {new Date(training.SessionEndDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </span>
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/duration.png"} alt="duration" /> {training.Duration} hours
                                            </span>
                                            <span>{training.Country}</span>
                                            <span>{training.Capability}</span>
                                            <span>{training.Category}</span>
                                        </div>
                                    </div>

                                    <div className="lc_dotted_divider-short"></div>
                                        <div className="lc_action_section">
                                            {showUser && (
                                            <div className="lc_edit_delete_group">
                                                <button
                                                className="lc_edit_btn"
                                                onClick={() => {
                                                     const normalizeDateForInput = (dateString) => {
                                                        if (!dateString) return "";
                                                        const d = new Date(dateString);
                                                        const year = d.getFullYear();
                                                        const month = String(d.getMonth() + 1).padStart(2, "0");
                                                        const day = String(d.getDate()).padStart(2, "0");
                                                        return `${year}-${month}-${day}`;
                                                    };
                                                    setEditCourse(training);
                                                    setEditForm({
                                                        ...training,
                                                        SessionStartDate: normalizeDateForInput(training.SessionStartDate),
                                                        SessionEndDate: normalizeDateForInput(training.SessionEndDate),
                                                    });
                                                    setEditModalOpen(true);
                                                }}
                                                title="Edit Training"
                                                >
                                                <img
                                                    src={process.env.PUBLIC_URL + "/images/LearningCalendar/edit-icon.png"}
                                                    alt="Edit"
                                                />
                                                </button>

                                                <button
                                                onClick={() => {
                                                    setSelectedCourse(training);
                                                    setDeleteModalOpen(true);
                                                }}
                                                className="lc_delete_btn"
                                                title="Delete Training"
                                                >
                                                <img
                                                    src={process.env.PUBLIC_URL + "/images/LearningCalendar/delete-icon.png"}
                                                    alt="Delete"
                                                />
                                                </button>
                                            </div>
                                            )}
                                            <a
                                                href={training.WorkdaySessionLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <button className="lc_register_sec">Register Now</button>
                                            </a>
                                        </div>
                                </div>
                            );
                        })
                    )}
                </div>

                {/* Right Side Calendar */}
                <Box
                    className="lc_calendar_right"
                >
                    {/* <Calendar /> */}
                    <CustomCalendar
                        startDate={startDate}
                        endDate={endDate}
                        setDateRange={setDateRange}
                    />
                </Box>

                {/* Pagination */}
                <div className="lc_pagination_controls">
                    <div className="lc_page_nav">
                        <img
                            src={process.env.PUBLIC_URL + "/images/LearningCalendar/left-arrow.png"}
                            alt="Previous"
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            className={`lc_arrow ${currentPage === 1 ? 'disabled' : ''}`}
                        />

                        <span className="lc_page_range">
                            {itemsPerPage === -1
                                ? `1 - ${filteredData?.length}`
                                : `${indexOfFirstItem + 1} - ${Math.min(indexOfLastItem, filteredData?.length)}`}
                        </span>
                        <span className="lc_page_total">of {filteredData?.length}</span>

                        <img
                            src={process.env.PUBLIC_URL + "/images/LearningCalendar/right-arrow.png"}
                            alt="Next"
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            className={`lc_arrow ${currentPage === totalPages ? 'disabled' : ''}`}
                        />
                    </div>

                    <div className="lc_page_dropdown">
                        Training list per page
                        <select
                            value={itemsPerPage === -1 ? 'all' : itemsPerPage.toString()}
                            onChange={(e) => {
                                const value = e.target.value;
                                setItemsPerPage(value === 'all' ? -1 : Number(value));
                                setCurrentPage(1);
                            }}
                        >
                            {[5, 10, 15, 20].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                            <option value="all">All</option>
                        </select>
                    </div>
                </div>
            </div>
            {deleteModalOpen && (
            <div className="lc_modal_overlay">
            <div className="lc_modal">
                <h3>Are you sure you want to delete this course?</h3>
                <p><strong>{selectedCourse?.CourseName}</strong></p>
                <div className="lc_modal_actions">
                <button
                    className="lc_btn_cancel"
                    onClick={() => setDeleteModalOpen(false)}
                >
                    No
                </button>
                <button
                    className="lc_btn_confirm"
                    onClick={confirmDelete}
                >
                    Yes
                </button>
                </div>
            </div>
            </div>
        )}
        {editModalOpen && (
            <div className="lc_modal_overlay">
                <div className="lc_modal lc_edit_modal">
                <h3 style={{color: "#460073"}}>Edit Training Session</h3>

                <div className="lc_edit_form">
                    <label>Course Name</label>
                    <input
                    type="text"
                    name="CourseName"
                    value={editForm.CourseName || ""}
                    onChange={handleEditChange}
                    />

                    <label>Country</label>
                    <input
                    type="text"
                    name="Country"
                    value={editForm.Country || ""}
                    onChange={handleEditChange}
                    />

                    <label>Capability</label>
                    <input
                    type="text"
                    name="Capability"
                    value={editForm.Capability || ""}
                    onChange={handleEditChange}
                    />

                    <label>Category</label>
                    <input
                    type="text"
                    name="Category"
                    value={editForm.Category || ""}
                    onChange={handleEditChange}
                    />

                    <label>Mode of Delivery</label>
                    <input
                    type="text"
                    name="ModeOfDelivery"
                    value={editForm.ModeOfDelivery || ""}
                    onChange={handleEditChange}
                    />

                    <label>Target Audience</label>
                    <input
                    type="text"
                    name="TargetAudienceLevel"
                    value={editForm.TargetAudienceLevel || ""}
                    onChange={handleEditChange}
                    />

                    <label>Start Date</label>
                    <input
                        type="date"
                        name="SessionStartDate"
                        value={editForm.SessionStartDate || ""}
                        onChange={handleEditChange}
                    />

                    <label>End Date</label>
                    <input
                        type="date"
                        name="SessionEndDate"
                        value={editForm.SessionEndDate || ""}
                        onChange={handleEditChange}
                    />
                </div>

                <div className="lc_modal_actions">
                    <button
                    className="lc_btn_cancel"
                    onClick={() => setEditModalOpen(false)}
                    >
                    Cancel
                    </button>
                    <button
                    className="lc_btn_confirm"
                    onClick={saveEditChanges}
                    >
                    Save
                    </button>
                </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default LearningCalendarComponent;
